var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import { debounce } from "lodash";
import id from "@irati/utils/id";
import { greys } from "@irati/ui/src/global/colors";
import FilterBy from "@irati/ui/src/FilterBy";
import { DropdownOverflow } from "@irati/ui/src/Dropdown";
import Input from "@irati/ui/src/FormItem/Input";
import LoadUsers, { userList } from "@irati/identity/apollo/query/UsersForBusiness";
import authentication from "@irati/auth";
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray";
import { injectIntl } from "@irati/utils/lang";
var InputWrapper = styled(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n"], ["\n  margin-bottom: 20px;\n"])));
var UserSearch = /** @class */ (function (_super) {
    __extends(UserSearch, _super);
    function UserSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function (event) {
            var filterOptions = _this.state.filterOptions;
            var updatedOptions = addOrRemoveFromArray(__spreadArrays(filterOptions), event.target.id);
            _this.setState({ filterOptions: updatedOptions });
        };
        _this.handleSelectAllFilters = function () {
            _this.setState({ filterOptions: [] });
        };
        _this.handleResetFilters = function () {
            _this.setState({ value: null, filterOptions: [] }, _this.handleFilter);
        };
        _this.handleUpdateSearch = function (value) {
            _this.setState({ value: value });
        };
        _this.handleClose = function () {
            _this.setState(function (state) { return ({ value: null, filterOptions: state.prevFilterOptions }); });
        };
        _this.handleFilter = function () {
            var filterOptions = _this.state.filterOptions;
            _this.setState({ prevFilterOptions: filterOptions }, function () {
                _this.props.onFilter(filterOptions);
                if (_this.dropdown && _this.dropdown.current) {
                    _this.dropdown.current.toggle();
                }
            });
        };
        _this.buildOptions = function (options) {
            var filterOptions = _this.state.filterOptions;
            return options.map(function (option) {
                return __assign(__assign({}, option), { isChecked: !!filterOptions.find(function (findOption) { return findOption === option.value; }) });
            });
        };
        _this.dropdown = React.createRef();
        _this.state = {
            filterOptions: [],
            prevFilterOptions: [],
            value: null
        };
        _this.handleUpdateSearch = debounce(_this.handleUpdateSearch, 250);
        return _this;
    }
    UserSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, role = _a.role;
        var _b = this.state, value = _b.value, filterOptions = _b.filterOptions;
        var idNamespace = id("DropdownFilter", this.props);
        return (React.createElement(DropdownOverflow, { ref: this.dropdown, width: 300, onToggle: this.handleClose, id: idNamespace, iconColor: filterOptions.length > 0 && greys.mediumDark },
            React.createElement(InputWrapper, null,
                React.createElement(Input, { label: "", name: "searchFilterBy", placeholder: formatMessage({ id: "admin.reportingV2.wallet.userSearch.placeholder" }), onChange: this.handleUpdateSearch, value: value })),
            React.createElement(LoadUsers, { variables: {
                    limit: 20,
                    offset: 0,
                    searchString: value,
                    role: role,
                    businessId: authentication.userTenant().uuid
                } }, function (apollo) {
                var options = userList(apollo)
                    .results.filter(function (user) { return !!user; })
                    .map(function (_a) {
                    var firstname = _a.firstname, lastname = _a.lastname, uuid = _a.uuid;
                    return ({ name: firstname + " " + (lastname || ""), value: uuid });
                });
                if (options.length <= 0) {
                    return formatMessage({ id: "admin.reportingV2.wallet.userSearch.empty" });
                }
                return (React.createElement(FilterBy, { id: id("filterWalletUsers", _this.props), filterOptions: _this.buildOptions(options), allOptionText: formatMessage({ id: "admin.reportingV2.wallet.search.all" }), resetButtonText: formatMessage({ id: "admin.reportingV2.wallet.search.reset" }), saveButtonText: formatMessage({ id: "admin.reportingV2.wallet.search.filter" }), onSelect: _this.handleSelect, onSelectAll: _this.handleSelectAllFilters, onReset: _this.handleResetFilters, onFilter: _this.handleFilter, useExpand: false, stopDisablingButtonsOnChange: true, isAllOptionChecked: function () { return filterOptions.length === 0; } }));
            })));
    };
    return UserSearch;
}(Component));
export default injectIntl(UserSearch);
var templateObject_1;
